import { ActionIcon, type ActionIconProps } from "@mantine/core";
import clsx from "clsx";
import type React from "react";

interface ButtonActionIconProps extends ActionIconProps {
  children: React.ReactNode;
  onClick?: () => void;
  showDefault?: boolean;
  title?: string;
}

const ButtonActionIcon = ({
  children,
  onClick,
  className,
  loading = false,
  showDefault = true,
  ...rest
}: ButtonActionIconProps) => {
  return (
    <ActionIcon
      {...rest}
      className={clsx(
        { "default-icon": showDefault },
        "hover-scale",
        className,
      )}
      classNames={{
        icon: "size-6",
      }}
      radius={12}
      size={50}
      onClick={onClick}
      loading={loading}
    >
      {children}
    </ActionIcon>
  );
};

export default ButtonActionIcon;
